import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseUpstreamFlowsFilteredByTableQuery, DatabaseUpstreamFlowsFilteredByTableQueryVariables, DatabaseUpstreamFlowsQuery, DatabaseUpstreamFlowsQueryVariables, FlowsDisplayGridRowDataFragment, FlowSortOrder , DatabaseUpstreamFlowsFilteredByTableDocument , DatabaseUpstreamFlowsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = DatabaseUpstreamFlowsQueryVariables;
type QueryResults = DatabaseUpstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseUpstreamFlowsFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseUpstreamFlowsFilteredByTableQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databases && resultData.databases[0] && resultData.databases[0].upstreamFlowsConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] && resultData.tables[0].upstreamFlowsConnection;
}


export type DatabaseUpstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly databaseId: string;
  readonly filteredTableId: string | null;
  readonly rowCount: number | null;
};

export function DatabaseUpstreamFlowsQueryGrid(props: DatabaseUpstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DatabaseUpstreamFlowsFilteredByTableDocument}
        partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseUpstreamFlowsDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    )
  )
}
